import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_TAGS = createActionTypes('FETCH_TAGS');
export const CREATE_TAGS = createActionTypes('CREATE_TAGS');
export const DELETE_TAGS = createActionTypes('DELETE_TAGS');
export const UPDATE_TAGS = createActionTypes('UPDATE_TAGS');
export const GET_TAG = createActionTypes('GET_TAG');
